import $ from 'jquery'

/* @ngInject */
const myTables = (
  excelLoader,
  storageHandler,
  toaster,
  utils,
  entities,
  labels,
  fields,
  icons,
  $filter
) => {
  return {
    restrict: 'E',
    scope: {
      myData: '=',
      myNature: '=',
      enableButtons: '=?',
      enableLinks: '=?',
      enableExcel: '=?',
      enableBadges: '=?',
      enableBack: '=?',
      disabledCtrl: '=?',
      myTrain: '=?',
      disabledList: '=?',
    },

    template: require('./myTables.html'),

    /* @ngInject */
    controller: ($scope) => {
      $scope.myOptions = {
        enableFilter: true,
        enablePanelCtrl: true,
        enableExcel: true,
      }

      $scope.show = {
        display: false,
        sort: false,
        excel: false,
      }

      $scope.order = []

      const resetAllAndToogleOne = (showObj, name) => {
        for (const key in showObj) {
          if (key === name) {
            showObj[key] = !showObj[key]
          } else {
            showObj[key] = false
          }
        }
      }

      $scope.panelButtons = [{
        options: {
          label: () => 'Afficher',
          icon: () => icons.display($scope.show.display),
          style: () => 'fill-width center' + ($scope.show.display ? ' retour' : ''),
        },
        click: () => { resetAllAndToogleOne($scope.show, 'display') },
      }, {
        options: {
          label: () => 'Trier',
          icon: () => icons.sort,
          style: () => 'fill-width center' + ($scope.show.sort ? ' retour' : ''),
        },
        click: () => { resetAllAndToogleOne($scope.show, 'sort') },
      }, {
        options: {
          label: () => 'Excel',
          icon: () => icons.excel,
          style: () => 'fill-width center' + ($scope.show.excel ? ' retour' : ''),
        },
        click: () => { resetAllAndToogleOne($scope.show, 'excel') },
      },]

      $scope.downloadButtonOptions = {
        label: () => 'Télécharger',
        icon: () => icons.download,
        style: () => '',
      }

      $scope.utils = utils
      $scope.entities = entities
      $scope.fields = entities[$scope.myNature].metadata.fields
      $scope.badges = entities[$scope.myNature].metadata.badges
      $scope.buttons = entities[$scope.myNature].metadata.buttons

      $scope.favoriteSort = entities[$scope.myNature].metadata.favoriteSort
      $scope.icons = icons

      $scope.removeFromList = (item) => {
        if (!$scope.myData || !item || !item.id) return
        $scope.myData = $scope.myData.filter(element => element.id !== item.id)
      }

      $scope.fieldsOptions = fields

      $scope.canEditAndSearch = false

      $scope.toggleEditAndSearch = () => {
        $scope.canEditAndSearch = !$scope.canEditAndSearch
      }

      $scope.saveList = () => {
        storageHandler.save('wagons-list-1', $scope.myData)
        toaster.message(`Enregistrement de la liste de ${$scope.myData.length} wagons`)
      }

      $scope.excelExport = false
      $scope.title = 'Export_SyGeM'

      $scope.excelRadio = {
        value: 'perso',
      }

      $scope.filter = ''
      $scope.filterOptions = {
        label: 'Filtrer',
        icon: 'search',
      }

      $scope.excelRadios = [{
        label: labels.export.personalisableExport,
        id: 'perso',
        value: 'perso',
        display: true,
      }, {
        label: labels.export.blank,
        id: 'blank',
        value: 'blank',
        display: true,
      }, {
        label: labels.export.parkCertificate,
        id: 'park',
        value: 'park',
        display: $scope.myNature === 'wagon',
      }, {
        label: labels.export.unparkCertificate,
        id: 'unpark',
        value: 'unpark',
        display: $scope.myNature === 'wagon',
      }, {
        label: labels.export.readinessCertificate,
        id: 'readiness',
        value: 'readiness',
        display: $scope.myNature === 'wagon',
      }, {
        label: labels.export.list,
        id: 'listing',
        value: 'listing',
        display: $scope.myNature === 'wagon',
      }, {
        label: labels.export.sort,
        id: 'sort',
        value: 'sort',
        display: $scope.myNature === 'wagon',
      }, {
        label: labels.export.dispositionSort,
        id: 'disposition',
        value: 'disposition',
        display: $scope.myNature === 'wagon',
      }, {
        label: labels.export.bulletinFreinage,
        id: 'bulletin',
        value: 'bulletin',
        display: $scope.myNature === 'wagon',
      }, {
        label: labels.export.compositionTrain,
        id: 'composition',
        value: 'composition',
        display: $scope.myNature === 'wagon',
      }, {
        label: labels.export.scrapping,
        id: 'scrapping',
        value: 'scrapping',
        display: $scope.myNature === 'wagon',
      },]

      $scope.download = (radioLabel) => {
        const filteredData = $filter('search')($scope.myData, $scope.filter)
        const data = []
        const options = getExcelOptions()

        if ($scope.myNature === 'wagon') {
          for (let i = 0; i < filteredData.length; i++) {
            data.push(entities[$scope.myNature].format.excel(filteredData[i]))
          }
        } else {
          data.push(...filteredData)
        }
        if (radioLabel === 'perso' || radioLabel === 'blank') {
          excelLoader.perso.download(radioLabel, data, options)
        } else {
          excelLoader.wagon.download(radioLabel, data, options)
        }
      }

      const getExcelOptions = () => {
        const title = $scope.title || 'sans titre'
        const sortOrder = $scope.order || []
        const fields = $scope.fields
        const data = $scope.myData
        const modelName = $scope.excelRadio.value
        const train = $scope.myTrain || {}
        return { title, sortOrder, fields, data, modelName, train, }
      }

      $scope.activeExcelMode = () => {
        $scope.displaySort = false
        $scope.displayCols = false
        $scope.excelExport = !$scope.excelExport
      }

      $scope.activeButton = () => {
        $('.dropdown-button').dropdown('open')
        $('.dropdown-button').dropdown()
      }

      let index = -1
      $scope.displayBadges = function (i) {
        if (index === -1) index = i
        return index === i
      }

      $scope.wagonLength = undefined

      $scope.$watch('myData', () => {
        if ($scope.myNature !== 'wagon') return undefined
        $scope.wagonLength = $scope.myData.reduce((acc, w) => acc + w.length, 0).toFixed(2)
      })

      $scope.$watch('myData.length', () => {
        if ($scope.myNature !== 'wagon') return undefined
        $scope.wagonLength = $scope.myData.reduce((acc, w) => acc + w.length, 0).toFixed(2)
      })
    },
    link: {
      pre: (scope, element, attrs) => {
        $('.dropdown-button').dropdown()
      },
      post: (scope, element, attrs, ctrl) => {
        $('.dropdown-button').dropdown()
      },
    },
  }
}

export default myTables



// WEBPACK FOOTER //
// ./public/javascript/sygem/global/directives/tables/myTables.js